import { getSize } from '../iterable/getSize';
import { get } from '../iterable/get';

import { PLACEHOLDERS } from '../../constants/forms';
import { ATTRIBUTE } from '../../constants/attributes';
import { AMOUNT } from '../../constants/product';
import { NONE } from '../../constants';

function argOrArray(arg) {
  return arg || [];
}

function getTopCategories({ taxonomyData }) {
  return argOrArray(get(['TAXONOMY', 'taxonomy', 'ids'])(taxonomyData));
}

export function getCategoryIndex({ category, taxonomyData }) {
  return getSize(get(['TAXONOMY', category, 'fullPath'])(taxonomyData)) - 1;
}

export function getCategoryName({ category, taxonomyData }) {
  switch (category) {
    case AMOUNT.MINUS_ONE: {
      return NONE;
    }

    case AMOUNT.ZERO: {
      return PLACEHOLDERS[ATTRIBUTE.CATEGORY];
    }

    default: {
      return get(['TAXONOMY', category, 'name'])(taxonomyData) || '';
    }
  }
}

export function getCategoryPath({ category, taxonomyData }) {
  return argOrArray(get(['TAXONOMY', category, 'fullPath'])(taxonomyData));
}

export function getCategoryChildren({ category, taxonomyData }) {
  if (!category || category === AMOUNT.ZERO) {
    return getTopCategories({ taxonomyData });
  }

  const path = getCategoryPath({ category, taxonomyData });

  return argOrArray(get(['TAXONOMY', 'taxonomy', ...path, 'ids'])(taxonomyData));
}

export function getCategorySiblings({ category, taxonomyData }) {
  if (!category || category === AMOUNT.ZERO) {
    return getTopCategories({ taxonomyData });
  }

  const path = getCategoryPath({ category, taxonomyData });

  switch (getSize(path)) {
    case 0: {
      return [];
    }

    case 1: {
      return getTopCategories({ taxonomyData });
    }

    default: {
      return argOrArray(get(['TAXONOMY', 'taxonomy', ...path.slice(0, -1), 'ids'])(taxonomyData));
    }
  }
}

export function getParentCategory({ category, taxonomyData }) {
  return get(['TAXONOMY', category, 'fullPath', 0])(taxonomyData);
}

export function getCategoryProperty({ category, propertyName, taxonomyData }) {
  return get(['CATEGORIES', category, 'properties', propertyName])(taxonomyData);
}
